import { SegmentedControl } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LotsColumnPreset } from './lots-column-preset';

export interface LotsColumnPresetControlProps {
  value: LotsColumnPreset;
  onChange: (preset: LotsColumnPreset) => void;
}

export const LotsColumnPresetControl: FC<LotsColumnPresetControlProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
      <SegmentedControl
        color="pf-green"
        size="xs"
        data={[
          {
            value: LotsColumnPreset.Tonnages,
            label: t('lots.presets.tonnages'),
          },
          {
            value: LotsColumnPreset.Surfaces,
            label: t('lots.presets.surfaces'),
          },
          {
            value: LotsColumnPreset.Rendements,
            label: t('lots.presets.rendements'),
          },
        ]}
        onChange={(v) => onChange(v as LotsColumnPreset)}
        radius="xs"
        value={value}
      />
  );
};

export default LotsColumnPresetControl;
